/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

export interface ShowcaseTab {
  label: string;
  value: string;
  iconName: string;
}

export interface ShowcaseTabsSignature {
  Args: {
    activeTab?: ShowcaseTab;
    onChangeTab: (tab: ShowcaseTab) => void;
    tabs: ShowcaseTab[];
  };
}

export default templateOnly<ShowcaseTabsSignature>();
